/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of a raffle or raffle drawing
 * @export
 */
export const RaffleStatus = {
    _11184809: '11184809',
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    AWAITING_DRAW: 'AWAITING_DRAW',
    CLOSED: 'CLOSED',
    unknown_default_open_api: '11184809'
} as const;
export type RaffleStatus = typeof RaffleStatus[keyof typeof RaffleStatus];


export function instanceOfRaffleStatus(value: any): boolean {
    for (const key in RaffleStatus) {
        if (Object.prototype.hasOwnProperty.call(RaffleStatus, key)) {
            if (RaffleStatus[key as keyof typeof RaffleStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RaffleStatusFromJSON(json: any): RaffleStatus {
    return RaffleStatusFromJSONTyped(json, false);
}

export function RaffleStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaffleStatus {
    return json as RaffleStatus;
}

export function RaffleStatusToJSON(value?: RaffleStatus | null): any {
    return value as any;
}

